import $ from 'jquery';

function sidenav() {
    var sidebarCtrl = $('#v-nav-primary')[0];
    $('.sidebar--primary').on('click', '.nav-ctrler', function(event) {
        event.preventDefault();
        $('.has-sub').removeClass('active');
        $(this).parent('.has-sub').toggleClass('active');
        // trigger open for collapsed sidebar
        if (!sidebarCtrl.checked) {
            sidebarCtrl.checked = true;
        }
    });
}

export { sidenav };